var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsAutomationsEventsPageVisited(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#EEB3FE",
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C309F6",
    className: "background"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 4c1.105 0 2 .895 2 2v6.131l.076.073-.076.079V26c0 1.105-.895 2-2 2H10c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h12zM10 15v11h12V15H10zm10 7c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L20 24h-8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L12 22h8zm-2-3c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L18 21h-6c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L12 19h6zm2-3c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L20 18h-8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L12 16h8zm-6.927-5.735l-.062.062L10.58 13h6.49l-2.584-2.678c-.375-.406-1.007-.431-1.413-.057zm5.865.94l-.093.079-.398.38L19.68 13H22v-.017l-1.77-1.699c-.357-.343-.905-.37-1.292-.08zM22 6H10v4.665l1.531-1.683c.06-.065.121-.127.185-.186 1.171-1.081 2.97-1.052 4.107.034l.133.135 1.134 1.23.37-.354c1.114-1.07 2.849-1.112 4.013-.128l.142.128.385.37V6z",
    transform: "translate(16 16)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsAutomationsEventsPageVisited);
export default __webpack_public_path__ + "static/media/illustrations-automations-events-page-visited.9face408.svg";
export { ForwardRef as ReactComponent };